define(
    'models/highlight_code.model',[
        'loader',
        'config',
        'helper',
        'sandbox'
    ],
    function (
        Loader,
        Config,
        Helper,
        Sandbox
        )
    {
        var _ = Loader._;

        var HighlightModel = Loader.Backbone.Model.extend({

            defaults: {
                enabled: false,
                scheme: 'default'
            },

            initialize: function()
            {
                var _this = this;
                this.model = this.get('model');

                this.setDefaults();

                this.bind('change:enabled', function(){
                    $.cookie('codemirror_enabled', _this.get('enabled'), { expires: 999 });
                });
                this.bind('change:scheme', function(){
                    $.cookie('codemirror_scheme', _this.get('scheme'), { expires: 999 });
                });
            },

            setDefaults: function()
            {
                if ($.cookie('codemirror_enabled') === null) {
                    $.cookie('codemirror_enabled', this.get('enabled'), { expires: 999 });
                }
                this.set('enabled', $.cookie('codemirror_enabled') === 'true');

                if ($.cookie('codemirror_scheme') === null) {
                    $.cookie('codemirror_scheme', this.get('scheme'), { expires: 999 });
                }
                this.set('scheme', $.cookie('codemirror_scheme'));
            }

        });

        return {
            initialize: function(model)
            {
                return new HighlightModel({
                    model: model
                })
            }
        }
    }
);

